import React from 'react';
import ReactDOM from 'react-dom';

import './stylesheets/main.scss';

import Editor from './components/Editor';

ReactDOM.render(
  <React.StrictMode>
    <Editor />
  </React.StrictMode>,
  document.getElementById('root')
);
